import React, { useState,useEffect } from 'react'
import firebase from '../../firebase'
import moment from 'moment'
import {
    BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer
} from 'recharts'
import _ from 'lodash'

const DashboardTwo = (props) => {

    const [data,setData] = useState([])

    useEffect(() => {
        const getUsers = new Promise (resolve => {
            firebase.getCollectionOnce('users').then(snap => {
                resolve(snap.docs.map(doc => doc.data()))
            })
        })
        const getCustomers = new Promise (resolve => {
            firebase.getCollectionOnce('customers').then(snap => {
                resolve(snap.docs.map(doc => doc.data()))
            })
        })
        const getBilling = new Promise (resolve => {
            const initialMonth = moment(props.month,'MM-YYYY').startOf('month').valueOf()
            const endMonth = moment(props.month,'MM-YYYY').endOf('month').valueOf()
            if (initialMonth && endMonth) {
                firebase.getCollectionRealTime('billing').where('date','<=',endMonth).where('date','>=',initialMonth).onSnapshot(snap => {
                    const billing = _.filter(snap.docs.map(doc => doc.data()), o => {
                        return o.status !== 'Cancelado'
                    })
                    const customers = _.uniqBy(billing, 'customerId')
                    var data = []
                    customers.forEach(cust => {
                        const filt = _.filter(billing, { customerId: cust.customerId })
                        const total = _.reduce(filt, (sum,n) => {
                            return sum + n.invoiceAmount
                        },0)
                        data.push({ name: cust.customerName, id: cust.customerId, total })
                    })
                    resolve(data)
                })
            }
        })
        getBilling.then(billing => {
            getUsers.then(users => {
                getCustomers.then(customers => {
                    var data = []
                    billing.forEach(bill => {
                        const customer = _.find(customers, { id: bill.id })
                        if (customer) {
                            const seller = _.find(users, { id: customer.sellerId })
                            if (seller) {
                                data.push({ total: bill.total, sellerId: seller.id, sellerName: seller.name })
                            }
                        }
                    })
                    setData(data)
                })
            })
        })
    },[props.month])

    const sellers = _.uniqBy(data,'sellerId')
    const filter = _.reduce(sellers, (arr,n) => {
        const sales = _.filter(data, { sellerId: n.sellerId })
        const tot = _.reduce(sales, (sum,i) => {
            return sum + i.total
        },0)
        return _.concat(arr,{ sellerName: n.sellerName, total: tot })
    },[])

    return (
        <div className="dashboard-two">
            <ResponsiveContainer width="100%" height={300}>
                <BarChart
                    data={filter}
                >
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey="sellerName" />
                    <YAxis />
                    <Tooltip />
                    <Legend />
                    <Bar dataKey="total" fill="#335AA6" />
                </BarChart>
            </ResponsiveContainer>
        </div>
    )
}

export default DashboardTwo